// Loading Spinner Component
import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', fullScreen = false }) => {
  const sizes = {
    small: '24px',
    medium: '40px',
    large: '60px'
  };

  const spinnerSize = sizes[size];

  const spinner = (
    <div
      className="nln-spinner"
      style={{
        width: spinnerSize,
        height: spinnerSize,
        border: `3px solid rgba(12,34,57,0.08)`,
        borderTop: `3px solid #03A84A`,
        borderRadius: '50%',
        animation: 'nlnSpin 0.75s linear infinite',
      }}
    />
  );

  if (fullScreen) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '80px 40px',
          flexDirection: 'column',
          gap: '16px',
        }}
      >
        {spinner}
        <p style={{ margin: 0, color: '#94A3B8', fontSize: '13px', fontWeight: '500' }}>Loading…</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      {spinner}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
